import React, { useCallback, useEffect, useMemo } from 'react'
import styles from 'components/TicketsPanel/panel.module.scss'
import clsx from 'clsx'
import Ticket from 'modules/Tickets/Ticket'
import TicketList from 'modules/Tickets/List'
import { Button, Icon } from 'gu-ui-kit'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import { useDispatch, useSelector } from 'react-redux'
import { PANEL_NAVIGATE, TOGGLE_PANEL } from 'modules/Tickets/types'

const LAYOUTS = {
  list: TicketList,
  ticket: Ticket,
  new_ticket: Ticket,
}

const Panel = () => {
  const dispatch = useDispatch()
  const breakpoints = useBreakpoint()
  const { openPanel, router: ticketPanelRouter } = useSelector(
    ({ tickets }) => tickets,
  )

  const LayoutComponent = useMemo(
    () => LAYOUTS[ticketPanelRouter.route],
    [ticketPanelRouter],
  )

  const navTo = useCallback((newRoute) => {
    dispatch({ type: PANEL_NAVIGATE, payload: newRoute })
  }, [])

  useEffect(() => {
    document.body.style.overflow = openPanel ? 'hidden' : 'visible'
  }, [openPanel])

  return (
    <>
      <div
        className={clsx(styles['tickets-panel__overlay'], {
          [styles['tickets-panel__overlay_open']]: openPanel,
        })}
        onClick={() => dispatch({ type: TOGGLE_PANEL, payload: false })}
      />
      <div
        className={clsx(styles['tickets-panel__container'], {
          [styles['tickets-panel__container_open']]: openPanel,
        })}
      >
        <Button
          className={styles['tickets-panel__close-button']}
          onClick={() => dispatch({ type: TOGGLE_PANEL, payload: false })}
          noLabel
          variant={'ghost'}
          grey
          size={breakpoints.sm ? 's' : 'm'}
          startIcon={<Icon name={'close'} />}
        />
        <div className={styles['tickets-panel__content']}>
          <LayoutComponent navTo={navTo} params={ticketPanelRouter.params} />
        </div>
      </div>
    </>
  )
}

export default Panel
